export default {"src":"/_next/static/media/logo-volts.1a38c6f4.svg","height":75,"width":176,"blurWidth":0,"blurHeight":0};